<template><div><h1>VUX V2.9.1 released</h1>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[feature] add isVisible function for AlertPlugin #2704</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] add isVisible function for ConfirmPlugin #2704</li>
</ul>
<h2><a href="/en/components/loading.html">Loading</a></h2>
<ul><li>[feature] add isVisible function for LoadingPlugin #2704</li>
<li>[fix] fix covered by element when using scroll plugins</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] fixed popup has black border on the right #2651</li>
</ul>
<h2><a href="/en/components/qrcode.html">Qrcode</a></h2>
<ul><li>[fix] fix missing support for Chinese works #2652</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[fix] fix box-sizing issue #2621. thanks to @suncodeer</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[feature] add isVisible function for ToastPlugin #2704</li>
</ul>
<h2><a href="/en/components/x-circle.html">XCircle</a></h2>
<ul><li>[feature] support show percent anticlockwise</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.1-150.vue?1f11e988